import React, { useEffect, useState } from 'react';
import { ImageViewer } from 'antd-mobile-v5';
import './index.scss';

import installationDiagram from '../../../../assets/product-interaction/joys550/joys550_installation_diagram.png';
import checkValveBeforeMeter from '../../../../assets/product-interaction/joys550/joys550_check_valve_before_meter.png';
import noCheckValveAfterMeter from '../../../../assets/product-interaction/joys550/joys550_no_check_valve_after_meter.png';
import incorrectInstallation from '../../../../assets/product-interaction/joys550/joys550_incorrect_installation.png';
import wiringDiagram from '../../../../assets/product-interaction/joys550/joys550_wiring.jpg';

const installationSteps = [
  ['选择合适位置', '便于抄表和维修，并做好防晒、防冻、防积水措施。'],
  ['安装前冲洗管道', '清除泥沙、石子、焊渣等杂物，避免水表堵塞损坏。'],
  ['表前安装止回阀', '水表前必须安装止回阀，减少反向水流对计量运行的影响。'],
  ['预留前后直管段', '前直管段不小于 10D，后直管段不小于 5D。'],
  ['按水流方向安装', '水表箭头方向与实际水流一致，严禁装反、倒装或倾斜安装。'],
  ['保持满水运行', '避免空气进入，建议出水口或水龙头高于水表 0.5m 以上。']
];

const ZoomableImage = ({ src, alt, eager = false, onPreview }) => (
  <button className="joys550-image-button" type="button" onClick={() => onPreview(src)} aria-label={`放大查看：${alt}`}>
    <img src={src} alt={alt} loading={eager ? 'eager' : 'lazy'} decoding="async" />
  </button>
);

const JOYS550Installation = () => {
  const [activeTab, setActiveTab] = useState('installation');
  const [previewImage, setPreviewImage] = useState('');

  useEffect(() => {
    document.title = 'JOYS550｜安装与接线说明';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="joys550-guide-shell">
      <main className="joys550-guide-page">
        <header className="joys550-guide-toolbar">
          <a href="/product/joys550" aria-label="返回 JOYS550 产品页"><span aria-hidden="true">‹</span></a>
          <h1>JOYS550 安装说明</h1>
        </header>

        <nav className="joys550-guide-tabs" aria-label="安装说明分类">
          <button
            type="button"
            className={activeTab === 'installation' ? 'is-active' : ''}
            aria-pressed={activeTab === 'installation'}
            onClick={() => setActiveTab('installation')}
          >
            安装说明
          </button>
          <button
            type="button"
            className={activeTab === 'wiring' ? 'is-active' : ''}
            aria-pressed={activeTab === 'wiring'}
            onClick={() => setActiveTab('wiring')}
          >
            接线说明
          </button>
        </nav>

        {activeTab === 'installation' ? (
          <div className="joys550-guide-content" data-testid="joys550-installation-content">
            <section className="joys550-guide-section">
              <h2>标准安装示意图</h2>
              <ZoomableImage
                src={installationDiagram}
                alt="JOYS550 水表标准安装示意图"
                eager
                onPreview={setPreviewImage}
              />
              <p className="joys550-image-note">水表箭头方向应与实际水流方向一致</p>
            </section>

            <section className="joys550-guide-section">
              <h2>管接头安装位置</h2>
              <div className="joys550-connector-grid">
                <article>
                  <ZoomableImage
                    src={checkValveBeforeMeter}
                    alt="带止回阀管接头安装在水表前端"
                    onPreview={setPreviewImage}
                  />
                  <h3>带止回阀管接头</h3>
                  <p>安装在水表前端。内置阀芯仅提供辅助止回作用，不能替代外部专用止回阀。</p>
                </article>
                <article>
                  <ZoomableImage
                    src={noCheckValveAfterMeter}
                    alt="不带止回阀管接头安装在水表后端"
                    onPreview={setPreviewImage}
                  />
                  <h3>不带止回阀管接头</h3>
                  <p>安装在水表后端。通孔、无阀芯，用于水表后端连接。</p>
                </article>
              </div>
              <p className="joys550-section-note">以上为源一水表出厂标配的一对管接头。</p>
            </section>

            <section className="joys550-guide-section">
              <h2>安装施工要点</h2>
              <ol className="joys550-installation-list">
                {installationSteps.map(([title, description]) => (
                  <li key={title}>
                    <strong>{title}</strong>
                    <span>{description}</span>
                  </li>
                ))}
              </ol>
            </section>

            <section className="joys550-guide-section joys550-error-section">
              <h2>常见安装错误</h2>
              <ZoomableImage
                src={incorrectInstallation}
                alt="JOYS550 水表六类常见错误安装示例"
                onPreview={setPreviewImage}
              />
              <p>错误安装会影响计量准确性并缩短水表寿命，请严格按照安装规范施工。</p>
            </section>
          </div>
        ) : (
          <div className="joys550-guide-content" data-testid="joys550-wiring-content">
            <section className="joys550-guide-section joys550-wiring-section">
              <h2>JOYS550 通讯接线图</h2>
              <ZoomableImage
                src={wiringDiagram}
                alt="JOYS550 水表通过 RS485 接入 GW214 采集器接线图"
                eager
                onPreview={setPreviewImage}
              />
              <p className="joys550-image-note">水表通讯线采用 RVSP 2×0.5 双绞屏蔽线</p>
            </section>
          </div>
        )}

        <ImageViewer image={previewImage} visible={Boolean(previewImage)} onClose={() => setPreviewImage('')} />
      </main>
    </div>
  );
};

export default JOYS550Installation;
